import React, { Component } from "react";

export default class SeniorenplatformFilter extends Component {
    constructor(props){
        super();
    }
        
    checkCheckboxValue(value){
        return this.props.activeFilters && this.props.activeFilters?.includes(value);
    }
    
    render(){
        return (
            <div className="c-senioren__filter">
                <h6 className="c-senioren__filter-label">{this.props.label}</h6>
                {this.props.filter !== undefined && this.props.filter !== null &&
                this.props.filter.map((value, index) => (
                    <div className="c-senioren__filter-item" key={index}>                
                        <div className="c-input__group">
                            <input type="checkbox"
                            id={`"checkbox-${value}"`} 
                            className='c-senioren__filter-item-checkbox'
                            onChange={e => this.props.handleCheckbox(e, value)}
                            checked={this.checkCheckboxValue(value)}/>
                            <label htmlFor={`"checkbox-${value}"`} 
                            className='c-senioren__filter-item-label'>{value}</label>
                        </div>
                    </div>
                ))}
            </div>
        );
    }
}